import { useParams } from "react-router-dom";

export default function TabLayout({ children }: { children: React.ReactNode }) {
  const { sectionId } = useParams();

  if (!sectionId) return null;

  return (
    <>
      <div className="flex flex-col" data-testid="tab-content">
        {children}
      </div>
    </>
  );
}
